import {
  Circle,
  CircleInfo, PolygonInterface, RemovedConfigType, TubeConfiguration, UpdateTubeConfiguration,
} from '../tubeChartTypes';

export function getUpdateTubePayload(
  jobOrder:string,
  vesselId: string,
  polygonList:PolygonInterface[],
  chartList:TubeConfiguration[],
  vesselTopRed: string,
  addingToLibrary:boolean,
) {
  const detailsPayload:TubeConfiguration[] = polygonList.map((poly:PolygonInterface, index:number) => {
    const circleArray:CircleInfo[] = [];
    const rotatedCircleArray:CircleInfo[] = [];
    const removedConfig:RemovedConfigType = {};
    poly.circles.forEach((circleArr:Circle[]) => {
      circleArr.forEach((value:Circle) => {
        const circle:CircleInfo = {
          Position: `${value.x},${value.y}`,
          Fill: value.visible ? '#00FFFFFF' : '#00FFFFFF',
          Stroke: value.visible ? '#FF000000' : '#00FFFFFF',
        };

        if (!value.visible) {
          if (removedConfig[value.x]) {
            removedConfig[value.x].push(value.y);
          } else {
            removedConfig[value.x] = [value.y];
          }
        }
        circleArray.push(circle);
      });
    });

    if (addingToLibrary === true && chartList[0]?.Offset === '1') {
      const columnCount = Math.max(...poly.circles.map((row) => row.length), 0);

      for (let column = 0; column < columnCount; column += 1) {
        poly.circles.forEach((row:Circle[]) => {
          const value = row[column];

          if (value) {
            rotatedCircleArray.push({
              Position: `${value.x},${value.y}`,
              Fill: '#00FFFFFF',
              Stroke: value.visible ? '#FF000000' : '#00FFFFFF',
            });
          }
        });
      }
    }

    const {
      IsOte,
      TubeSize,
      NumOfRows,
      RowLength,
      Panel,
      Group,
      Layout,
      IsTestEndChanges,
      ChartId,
      Offset,
      OriginalTestEnd,
    } = chartList[index];

    return {
      // CircleInfos: circleArray,
      CircleInfos: (addingToLibrary === true && chartList[0]?.Offset === '1') ? rotatedCircleArray : circleArray,
      IsOte,
      TubeSize,
      NumOfRows,
      RowLength,
      Panel,
      Group,
      Layout,
      IsTestEndChanges,
      ChartId,
      VesselId: vesselId,
      VesselTop: vesselTopRed,
      Offset,
      OriginalTestEnd,
      RemovedConfig: removedConfig,
    };
  });

  const payload:UpdateTubeConfiguration = {
    JobOrder: jobOrder,
    details: detailsPayload,
  };

  return payload;
}
